export default "__VITE_ASSET__D2u5LUA3__"